var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{staticStyle:{"width":"100%","height":"700px"},attrs:{"id":"t0_iframe","frameborder":"0","allowfullscreen":"true","webkitallowfullscreen":"true","mozallowfullscreen":"true","src":_vm.$data_url+'archivos/upload/libro/' + _vm.url}})])
}
var staticRenderFns = []

export { render, staticRenderFns }